import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import styles from "./Print.module.scss";
import classnames from "classnames";
import { openPDFTab } from "../utils";

class PrintPages extends React.PureComponent {
    render() {
        const { pages, svgData } = this.props;
        return (
            <div className={styles["print-wrapper"]}>
                <div
                    className={classnames(styles["page-wrapper"], styles["svg-label-wrapper"])}
                    dangerouslySetInnerHTML={{
                        __html: svgData?.replace("<svg ", '<svg viewbox="0 0 290 540" '),
                    }}
                />
                {pages?.map((page, index) => {
                    return (
                        <div key={index} className={classnames(styles["page-wrapper"], "p3")}>
                            {page}
                        </div>
                    );
                })}
            </div>
        );
    }
}

// Note that pages only work if we receive an SVG
export function PrintLabelComponent({ pages, shipmentLabelService, onPrint, printEnabled = true }) {
    const componentRef = useRef();

    const [readyToPrint, setReadyToPrint] = useState(false);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    useEffect(() => {
        if (shipmentLabelService.data) {
            setReadyToPrint(true);
        } else {
            setReadyToPrint(false);
        }
    }, [shipmentLabelService]);

    useEffect(() => {
        if (readyToPrint && printEnabled) {
            if (shipmentLabelService.data.format === "SVG" || pages?.length > 0) {
                handlePrint();
            }
            if (shipmentLabelService.data.format === "PDF") {
                openPDFTab(shipmentLabelService?.data?.data);
            }
            setReadyToPrint(false);
            onPrint && onPrint();
        }
    }, [readyToPrint, shipmentLabelService, printEnabled]);

    return <PrintPages ref={componentRef} pages={pages} svgData={shipmentLabelService?.data?.format === "SVG" ? shipmentLabelService?.data?.data : null} />;
}
